module.exports = __webpack_public_path__ + "static/media/richard.5de1f521.jpg";